<div class="alert-container">
    <div class="alert-content" *ngIf="!overlayConfig.contentTemplate">
        <div class="alert-text-wrapper">
            <span class="fa alert-icon"
                [ngClass]="{'fa-info-circle alert-info-icon':overlayConfig.type==='info','fa-exclamation-triangle alert-warning-icon':overlayConfig.type==='warning','fa-check-circle alert-successful-icon':overlayConfig.type==='successful','fa-times-circle alert-error-icon':overlayConfig.type==='error'}"></span><span class="alert-text">{{text}}</span>
        </div>
    </div>
    <div class="alert-content" *ngIf="overlayConfig.contentTemplate">
        <div *ngTemplateOutlet="overlayConfig.contentTemplate;context:{close:closeFun}"></div>
    </div>
    <div class="alert-actions" *ngIf="overlayConfig.showAction">
        <div *ngIf="overlayConfig.actionTemplate">
            <div class="alert-content" *ngTemplateOutlet="overlayConfig.actionTemplate;context:{close:closeFun}"></div>
        </div>
        <div *ngIf="!overlayConfig.actionTemplate">
            <ad-button (click)="close()">OK</ad-button>
        </div>
    </div>
</div>